import { flattenProp } from 'recompose'
import { createStructuredSelector } from 'reselect'

import { fetchPosts } from 'wordpress/actions'
import { componentSelector } from 'wordpress/selectors'
import { withWordpressLanguage } from 'wordpress/utils'

import { ticketSelector } from '../selectors'
import '../styles/Offers.scss'

const CustomLink = ({ children, buttonAction, url, page, className }) => {
    const props = {
        ...(buttonAction === 'page' ? { to: page } : { href: url }),
        className,
    }
    return buttonAction === 'page' ? <Link {...props}>{children}</Link> : <a {...props}>{children}</a>
}

const AllTicketsCard = ({ moreLabel, buttonAction, page, url }) => {
    const getLink = children => {
        const props = {
            ...(buttonAction === 'page' ? { to: page } : { href: url }),
        }

        return buttonAction === 'page' ? <Link {...props}>{children}</Link> : <a {...props}>{children}</a>
    }

    return (
        <div className="card all-tickets">
            <div className="card-block">
                {getLink(
                    <>
                        <h4>{moreLabel}</h4>
                        <span className="arrow-right" />
                    </>
                )}
            </div>
        </div>
    )
}

const $TicketCard = props => {
    const { ticket, title, type, shortDescription, buttonLabel } = props
    let buttonAction
    let url
    let page

    if (ticket && ticket.singleButtonAction) {
        buttonAction = ticket.singleButtonAction
        url = ticket.url
        page = ticket.to
    } else {
        buttonAction = props.buttonAction
        url = props.url
        page = props.page
    }

    return (
        <CustomLink buttonAction={buttonAction} className="card text-center" url={url} page={page}>
            <div className="card-header">
                <h4>{type}</h4>
                <hr />
                <h3>{title}</h3>
            </div>
            <div className="card-block">
                <p className="card-text">{shortDescription}</p>
            </div>
            <div className="card-footer">
                <button className="btn btn-outline-primary">{buttonLabel}</button>
            </div>
        </CustomLink>
    )
}

const TicketCard = compose(
    connect(
        createStructuredSelector({
            ticket: ticketSelector,
        })
    ),
    flattenProp('ticket')
)($TicketCard)

class Offers extends Component {
    componentDidMount() {
        this.props.fetchPosts('tickets')
    }

    render() {
        const { buttonAction, buttonLabel, moreLabel, page, title, tickets = [], url } = this.props

        if (!tickets.length) return null

        return (
            <div className="container-fluid" id="offers">
                <div className="container p-0">
                    <div className="row no-gutters">
                        <div className="header col text-center clearfix">
                            <h2>{title}</h2>
                        </div>
                    </div>

                    <div className="card-deck">
                        {tickets.map(id => (
                            <TicketCard
                                ticketId={id}
                                buttonAction={buttonAction}
                                buttonLabel={buttonLabel}
                                page={page}
                                url={url}
                                key={id}
                            />
                        ))}
                        <AllTicketsCard {...{ moreLabel, buttonAction, page, url }} />
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(withWordpressLanguage, connect(componentSelector('tickets'), { fetchPosts }))(Offers)
